import { ActionButtons, Button, Para, Stack } from '@drycut/ui-components';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';

type Props = {
  handleClose: () => void;
  loading?: boolean;
};

export function NoStylistsAvailableWarning({ handleClose, loading }: Props): React.ReactElement {
  return (
    <Stack>
      <Stack className="pt-8 pb-12 items-center" gap={3}>
        <ExclamationTriangleIcon className="size-10 text-orange-400" />

        <Stack className="w-80 items-center">
          <Para size="xl" pretty>
            Es sind keine Stylisten angemeldet, die Gutscheine ausstellen können.
          </Para>
        </Stack>
      </Stack>

      <ActionButtons>
        <Button type="button" fill="outlined" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
      </ActionButtons>
    </Stack>
  );
}
